import { render, staticRenderFns } from "./DisputeModal.vue?vue&type=template&id=09ff898b&"
import script from "./DisputeModal.vue?vue&type=script&lang=js&"
export * from "./DisputeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports